<template>
  <div class="house-importer-change-name-row">
    <div class="house-importer-change-name-row__input">
      <app-input :label="oldLabel" ref="oldValInput" @keydown.enter="focusOldInput" v-model="oldVal" @keydown.delete="goPrevRow"/>
    </div>

    <div class="house-importer-change-name-row__icon">
      <app-icon name="RightArrowIcon"/>
    </div>

    <div class="house-importer-change-name-row__input">
      <app-input :label="newLabel" ref="newValInput" @keydown.enter="goNextRow" v-model="newVal" @keydown.delete="goPrevCell"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: "ChangeNameRow",
    props: {
      oldLabel: {},
      newLabel: {},
      value: {}
    },
    computed: {
      oldVal: {
        get(){
          return this.getVal(0)
        },
        set(v){
          this.setVal(v, 0)
        }
      },
      newVal: {
        get(){
          return this.getVal(1)
        },
        set(v){
          this.setVal(v, 1)
        }
      }
    },
    methods: {
      getVal(index){
        let v = this.value.split('=');

        if(v.length){
          let v0 = v[index];
          return v0.replace(/\|/g, '');
        }
        else{
          return null
        }
      },
      setVal(v, index){
        v = v === null ? "" : v.trim();
        let oldVal = this.value.split('=');
        oldVal[index] = `|${v}|`;
        this.$emit('change', oldVal.join('='));
        this.$nextTick(() => {
          this.checkForDelete();
        });

      },
      checkForDelete(){
        if(!this.oldVal.length && !this.newVal.length){
          this.$emit('delete');
        }
      },
      focusOldInput(){
        this.$refs.newValInput.focus();
      },
      focusNewInput(){
        this.$refs.oldValInput.focus();
      },
      goNextRow(){
        this.$emit('go-next-row');
      },
      goPrevRow(event){
        if(!this.oldVal.length) {
          event.preventDefault();
          this.$emit('go-prev-row');
        }
      },
      goPrevCell(event){
        if(!this.newVal.length){
          event.preventDefault();
          this.focusNewInput();
        }
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-change-name-row{
    display: flex;
    align-items: center;

    &__icon{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      margin-top: 20px;
    }

    &__input{
      flex: 1;
    }
  }
</style>